/**
 * Fields that can be required via confirm-on-exit or confirm-on-entry column rules.
 * Values must match the corresponding BoardTask field names (snake_case).
 */
export enum ConfirmableField {
  ESTIMATED_POMODOROS = 'estimated_pomodoros',
  ACTUAL_POMODOROS = 'actual_pomodoros',
}
